import React from "react";
import { Form, Button } from "react-bootstrap";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CancelIcon from "@mui/icons-material/Cancel";

const FileUploadComponent = ({ setSelectedFile = () => { }, fileName,setFileName= () => { }, fileType = ""}) => {
  const fileInputRef = React.useRef();


  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      setSelectedFile(file);
      setFileName(file.name);
    }
  };

  const handleCancel = (event) => {
    event.stopPropagation();
    setSelectedFile(null);
    setFileName("");
    fileInputRef.current.value = null;
  };

  const handleLabelClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div>
      <Form>
        <Form.Group controlId="formFile" className="mb-3">
          <input
            type="file"
            onChange={handleFileChange}
            accept={fileType}
            id="upload"
            style={{ display: "none" }}
            ref={fileInputRef}
          />
          <div
            htmlFor="upload"
            className="btn btn-primary upload-label w-100 d-flex justify-content-between align-items-center"
            onClick={handleLabelClick}

          >
            <div className="d-flex align-items-center">
              <CloudUploadIcon style={{ color: "grey" }} />
              <span style={{ color: "grey", marginLeft: "10px" }}> {fileName || "Upload"}</span>
            </div>

            {fileName && (
              <Button variant="danger" onClick={handleCancel}>
                <CancelIcon />
              </Button>
            )}
          </div>
        </Form.Group>
      </Form>
    </div>
  );
};

export default FileUploadComponent;
